import React, { Component } from 'react'
import TextField from 'material-ui/TextField'
import { connect } from 'react-redux'
import { api } from "../../../../../../api/index"
import PromotionVariantActionsTop from './includes/actionsTop';
import PromotionVariantActionsBottom from './includes/actionsBottom';

class PromotionVariantAnchorCTAComponent extends Component {
	constructor(props) {
		super(props);

		this.handlePositionFieldState = this.handlePositionFieldState.bind(this);
	}

	handlePositionFieldState(event) {

		const target = event.target;
		const name = target.name;
		const value = target.value;

		api.promotions.handlePositionFieldState( name, value, this.props.periodKey, this.props.variantKey );
	}

	render() {
		const variant = this.props.promotion.periods[this.props.periodKey].variants[this.props.variantKey];

        return (
			<div className={undefined === variant.active || true === variant.active ? 'medium-12 cell promotion__variation' : 'medium-12 cell promotion__variation promotion__variation--inactive' }>
				<PromotionVariantActionsTop handleActive={this.props.handleActive} removeVariation={this.props.removeVariation} periodKey={this.props.periodKey} variantKey={this.props.variantKey} />
				<div className="grid-x grid-margin-y grid-padding-x grid-margin-x">
					<div className="medium-12 cell">
						<label>
							Prefix
							<TextField
								onChange={this.handlePositionFieldState}
								value={this.props.promotion.periods[this.props.periodKey].variants[this.props.variantKey].prefix}
								id={'anchorcta-' + this.props.periodKey + '-variant-' + this.props.variantKey + '-prefix' }
								fullWidth={true}
								multiLine={true}
								name="prefix"
							/>
							<small>Bijv: "ZIE OOK:"</small>
						</label>
					</div>
                    <div className="medium-12 cell">
                        <label>
                            Tekst
                            <TextField
                                onChange={this.handlePositionFieldState}
                                value={this.props.promotion.periods[this.props.periodKey].variants[this.props.variantKey].text}
                                id={'anchorcta-' + this.props.periodKey + '-variant-' + this.props.variantKey + '-text' }
                                fullWidth={true}
                                multiLine={true}
                                name="text"
                            />
                        </label>
                    </div>
                </div>
				<PromotionVariantActionsBottom
					periodKey={this.props.periodKey}
					variantKey={this.props.variantKey}
				/>

			</div>
		)
    }
}

const mapStateToProps = ( state ) => {
	return {
		promotion: state.promotion
	}
}

export default connect(mapStateToProps)(PromotionVariantAnchorCTAComponent)


// WEBPACK FOOTER //
// ./src/application/components/promotions/components/types/variants/anchorCTA.js